import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';
import { createTheme, ThemeProvider } from '@mui/material/styles';


import VisibilityIcon from '@mui/icons-material/Visibility';
import Delete from '@mui/icons-material/Delete';
import { format, isSameDay, isSameMonth } from 'date-fns';

// import { useNavigate } from 'react-router-dom';
import * as React from 'react';
// import TextField from '@mui/material/TextField';
// import Autocomplete from '@mui/material/Autocomplete';
// @mui
import {
  Container,
  Typography,
  Stack,
  Button,
  TextField,
  Modal,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

import Iconify from '../components/iconify';

// api
import {
  validateUser,
  getGenericData,
  updateGenericData,
  getUsuarios,
  getUnoProposta,
  updateProposta,
  deleteGenericData,
} from './api';
import config from '../config.json';
import PopoverFiltroUsuario from './PopoverFiltroUsuario';

import AddProposta from './AddProposta';

const theme = createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          width: '36px', // Example: Adjust as needed
          height: '36px', // Example: Adjust as needed
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    MuiDayPicker: {
      styleOverrides: {
        weekDayLabel: { // For the D, S, T, Q, Q, S, S headers
          width: '36px',
          height: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        weekContainer: { // For the row containing the days
          display: 'flex',
          justifyContent: 'space-around', // Or 'space-between', 'center', etc.
          alignItems: 'center',
          width: '100%',
        },
      },
    },
  },
});

// ----------------------------------------------------------------------

export default function Agenda() {
  // Valida usuario
  const navigate = useNavigate();
  useEffect(() => {
    validateuser();
  }, []);
  const validateuser = async () => {
    const teste = await validateUser();
    if (!teste.ok) {
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {};
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente');
      return;
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario;
  };
  // -------------
  // Outras funcoes e declaracoes
  // ---------------------
  // Modal
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
  // Filtro ----
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
  const emptyFiltro = {
    usuarioLogadoAgenda: usuarioLogado,
    datainicialAgenda: primeiroDiaDoMes,
    datafinalAgenda: ultimoDiaDoMes,
  };
  const [filtro, setFiltro] = useState({ ...emptyFiltro });
  const [openFiltro, setOpenFiltro] = useState(null);

  const onCloseFiltro = () => {
    setOpenFiltro(null);
  };

  const limparFiltro = () => {
    setFiltro({ ...emptyFiltro });
    setOpenFiltro(null);
  };

  const onConfirmFiltro = (filtroPopover) => {
    setFiltro(filtroPopover);
    setOpenFiltro(null);
  };

  const [agendas, setAgendas] = useState([]);
  useEffect(() => {
    getAgendas();
  }, [filtro]);

  const getAgendas = async () => {
    const result = await getGenericData('agenda', filtro);
    setAgendas(result);
  };


  const [selectedDate, setSelectedDate] = useState(new Date());
  const [openModal, setOpenModal] = useState(false);
  const [agendasDoDia, setAgendasDoDia] = useState([]);
  const [novaAgenda, setNovaAgenda] = useState({
    usuario: '',
    dataAgenda: new Date(),
    descricao: '',
  });

  // abrir modal com agendas do dia
  const handleDayDoubleClick = (date) => {
    const agendasFiltradas = agendas.filter((a) => isSameDay(new Date(a.dataAgenda), date));
    setAgendasDoDia(agendasFiltradas);
    setOpenModal(true);
  };

  // renderiza cada dia com marcação se tiver agenda
  const renderDay = (day, _value, DayComponentProps) => {
    const temAgenda = agendas.some((a) => isSameDay(new Date(a.dataAgenda), day));

    return (
      <div
        {...DayComponentProps}
        onDoubleClick={() => handleDayDoubleClick(day)}
        style={{
          backgroundColor: temAgenda ? '#A5D6A7' : 'transparent',
          borderRadius: '50%',
          padding: '6px',
          cursor: 'pointer',
        }}
      >
        {format(day, 'd')}
      </div>
    );
  };


  const [open, setOpen] = React.useState(false);
  const [produto, setProduto] = React.useState(null);

  const handleVisualiza = async (row) => {
    const proposta = await getUnoProposta({ _id: row.idProposta });
    if (proposta) {
      const rowCopy = JSON.parse(JSON.stringify(proposta));
      setProduto(rowCopy);
      setOpen(true);
    } else {
      alert('Proposta não encontrada');
    }
  };

  const handleClose = () => {
    setOpen(false);
    setProduto(null);
  };

  const onConfirmHandler = async (proposta, anexo) => {
    try {
      const [result1, result2] = await Promise.all([updateProposta(proposta, anexo)]);
      setProduto(null);
      handleClose();
    } catch (error) {
      console.error('Erro ao atualizar as coleções:', error);
    }
  };

  const confirmDelete = async (a) => {
    await deleteGenericData('agenda', a);
    await getAgendas();
    setOpenModal(false);
  };

  // ----------------------

  return (
    <>
      <Helmet>
        <title> Agenda </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography variant="h4" sx={{ mb: 5 }}>
            Agenda
          </Typography>

          <Button
            onClick={(e) => setOpenFiltro(e.currentTarget)}
            variant="contained"
            startIcon={<Iconify icon="eva:search-fill" />}
            sx={{
              height: 50,
              minWidth: 100,
              backgroundColor: 'MediumSeaGreen',
              marginLeft: 'auto',
              '&:hover': { backgroundColor: 'SeaGreen' },
            }}
          >
            Filtros
          </Button>
        </Stack>
        <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          value={selectedDate}
          onChange={(newDate) => setSelectedDate(newDate)}
          renderDay={renderDay}
        />
      </LocalizationProvider>
    </ThemeProvider>
      </Container>

      {openFiltro ? (
        <PopoverFiltroUsuario
          filtro={filtro}
          open={openFiltro}
          onClose={onCloseFiltro}
          onLimpar={limparFiltro}
          onConfirm={onConfirmFiltro}
        />
      ) : null}
      {openModal && (
        <Modal open={openModal} onClose={() => setOpenModal(false)}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
              minWidth: 400,
            }}
          >
            <Typography variant="h6" gutterBottom>
              Agendas do dia {format(novaAgenda.dataAgenda, 'dd/MM/yyyy')}
            </Typography>

            {agendasDoDia.map((a, idx) => (
              <Box key={idx} sx={{ mb: 1, p: 1, borderBottom: '1px solid #ccc' }}>
                <Typography variant="body2">
                  <strong>Usuário:</strong> {a.usuario?.nome}
                </Typography>
                <Typography variant="body2">
                  <strong>Cliente:</strong> {a.proposta?.cliente?.nome}
                </Typography>
                <Typography variant="body2">
                  <strong>Descrição:</strong> {a.descricaoAgenda}
                </Typography>
                <Stack direction={'row'} gap={10} mt={2}>
                  <Button
                    size="small"
                    variant="contained"
                    startIcon={<VisibilityIcon />}
                    onClick={() => handleVisualiza(a)}
                  >
                    Visualizar
                  </Button>

                  <Button
                    size="small"
                    variant="contained"
                    color="error"
                    startIcon={<Delete />}
                    onClick={() => confirmDelete(a)}
                  >
                    Excluir
                  </Button>
                </Stack>
              </Box>
            ))}
            {open && <AddProposta open={open} proposta={produto} onClose={handleClose} onConfirm={onConfirmHandler} />}
          </Box>
        </Modal>
      )}
    </>
  );
}
